import type { z } from 'zod';

import { statusMutationSchema } from '@/_schemas/status-input';

import { tcConditionQuerySchema } from './tc-condition-query-schema';

export const tcConditionUpdateSchema = tcConditionQuerySchema
  .omit({
    sku: true,
    terms_condition_category: true,
  })
  .extend({
    status: statusMutationSchema,
  });

export type TcConditionUpdateSchema = z.infer<typeof tcConditionUpdateSchema>;

export const tcConditionCreateSchema = tcConditionUpdateSchema.omit({
  id: true,
});

export type TcConditionCreateSchema = z.infer<typeof tcConditionCreateSchema>;
